import React from 'react'

interface ComponentProps {
  onClick: () => void
}

function Error({ onClick }: ComponentProps) {
  return (
    <div className="flex flex-col items-center space-y-8 px-2 text-center">
      <div className="text-3xl text-red-500">
        Something went wrong, please try again
      </div>
      <button
        type="button"
        className="w-2/4 rounded-lg bg-[#017EE4] text-white"
        onClick={onClick}
      >
        Rescan
      </button>
    </div>
  )
}

export default Error
